<template>
  <div class="section">
    <div v-if="noteTitle" class="flex justify-center mb-10">
      <span class="text-lg leading-5 font-black">{{ noteTitle }}</span>
    </div>
    <div v-if="title || subTitle || hasSlotTitle" class="section__title">
      <h2 v-if="title && !isModal" class="flex-1">{{ title }}</h2>
      <h3 v-if="title && isModal" class="flex-1 font-medium text-base text-gray-950">{{ title }}</h3>
      <slot name="slotTitle">
        <h2 v-if="slotTitle && !isModal" class="flex-1">{{ slotTitle }}</h2>
        <h3 v-if="slotTitle && isModal" class="flex-1 font-medium">{{ slotTitle }}</h3>
      </slot>
      <slot name="subTitle">
        <span v-if="subTitle">
          {{ subTitle }}
        </span>
      </slot>
    </div>
    <div class="section__subTitle">
      <slot name="sub" />
    </div>
    <div
      :class="[
        'section__body',
        {
          'section__body--no-title': !title && !hasSlotTitle,
        },
      ]"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: () => '',
    },
    subTitle: {
      type: String,
      required: false,
      default: () => '',
    },
    noteTitle: {
      type: String,
      default: () => null,
    },
    slotTitle: {
      type: String,
      required: false,
      default: () => '',
    },
    hasSlotTitle: {
      type: Boolean,
      default: () => false,
    },
    isModal: { type: Boolean, required: false, default: () => false },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/components/the-section.scss';
</style>
